	<app-auth-wrapper [title]="title">
		<p class="form-title">If an account exists, we'll send you an email containing a link to reset your password</p>
		<button (click)="backToLogin()" class="auth-form-button" kendoButton themeColor="primary">BACK TO LOGIN</button>
	</app-auth-wrapper>
